<!-- ConfirmationDialog.svelte -->
<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let message = "";

  const confirm = () => dispatch("confirm");
  const cancel = () => dispatch("cancel");
</script>

<div class="confirmation-dialog-overlay">
  <div class="confirmation-dialog">
    <p>{message}</p>
    <button on:click={confirm}>Ja, verwijder maar</button>
    <button on:click={cancel}>Nee, stop!</button>
  </div>
</div>

<style>
  .confirmation-dialog-overlay {
    /* Make it cover the entire screen */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    /* Semi-transparent black background */
    background-color: rgba(0, 0, 0, 0.5);

    /* Center the dialog */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .confirmation-dialog {
    /* You can style your dialog however you want */
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    z-index: 10000;
  }
</style>
